import React from 'react';

const AppControlCeilingFigure: React.FC = () => (
  <figure className="app-control-figure">
    <div className="app-control-figure__frame">
      <div className="app-control-diagram">
        <div className="app-control-diagram__agent">
          <strong>Model</strong>
          <span>plans the next action</span>
        </div>

        <div className="app-control-diagram__arrow" aria-hidden="true">↓ tool call</div>

        <section className="app-control-diagram__application" aria-label="Coding harness application layer">
          <header>
            <strong>Coding harness / editor</strong>
            <span>application layer</span>
          </header>
          <div className="app-control-diagram__app-tools">
            <span>indexed search</span>
            <span>vector database</span>
            <span>file tools</span>
            <span>JSON wrappers</span>
          </div>
          <p>Builds a smarter model of the machine from above.</p>
        </section>

        <div className="app-control-diagram__interface">
          <span>filesystem APIs</span>
          <span>file watchers</span>
          <span>shell commands</span>
        </div>

        <div className="app-control-diagram__boundary">
          <span>application control ends here</span>
        </div>

        <section className="app-control-diagram__system" aria-label="Operating system layer">
          <header>
            <strong>Filesystem + operating system</strong>
            <span>source of truth</span>
          </header>
          <div className="app-control-diagram__system-facts">
            <span>files</span>
            <span>processes</span>
            <span>ports</span>
            <span>memory</span>
            <span>scheduling</span>
            <span>isolation</span>
          </div>
          <p>Owns the state the harness can only observe and operate through.</p>
        </section>
      </div>
    </div>

    <figcaption className="app-control-figure__caption">
      Current coding harnesses make the application layer smarter, but still reach the machine through the interfaces exposed by the operating system.
    </figcaption>
  </figure>
);

export default AppControlCeilingFigure;
